import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let OfferHeader = class extends InternalElement {
  constructor() {
    super(...arguments);
    this.verticalDisplay = true;
  }
  render() {
    var _a, _b, _c;
    return html`
      <section id="offer-header" class=${classMap({ "vertical-display": this.verticalDisplay })}>
        <div id="promotional-header">
          <h1>
              ${((_a = this.quote) == null ? void 0 : _a.product.promotional_header) || ((_b = this.quote) == null ? void 0 : _b.product.friendly_name)}
          </h1>
          <slot></slot>
        </div>
        <div id="promotional-description" .innerHTML=${((_c = this.quote) == null ? void 0 : _c.product.promotional_description) || ""}></div>
      </section>
    `;
  }
};
OfferHeader.styles = css`
    #offer-header {
      display: flex;
      flex-direction: row;
      gap: var(--default-vi-offer-header-spacing);
    }
    
    h1 {
      font-size: var(--default-vi-promotional-header-font-size);
      font-weight: var(--default-vi-promotional-header-font-weight);
      font-family: var(--default-vi-promotional-header-font-family);
      color: var(--default-vi-promotional-header-color);
      margin: 0;
    }

    #promotional-description {
      font-family: var(--default-vi-promotional-description-font-family);
      font-size: var(--default-vi-promotional-description-font-size);
      font-weight: var(--default-vi-promotional-description-font-weight);
      color: var(--default-vi-promotional-description-color);
      flex: 1;
    }
  
    #promotional-description * {
      margin: 0;
    }
  
    #promotional-description h1, 
    #promotional-description h2, 
    #promotional-description h3, 
    #promotional-description h4 {
      display: flex;
      align-items: center;
    }

    #promotional-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    slot {
      font-size: var(--default-vi-font-xl);
    }
    
    section#offer-header.vertical-display {
      flex-direction: row;
      gap: var(--default-vi-offer-header-spacing);
    }

    @media (max-width: 900px) {
      #offer-header {
        flex-direction: column;
        gap: var(--default-vi-offer-header-spacing);
      }

    }

    @container (max-width: 900px) {
      #offer-header {
        flex-direction: column;
        gap: var(--default-vi-offer-header-spacing);
      }

      section#offer-header.vertical-display {
        flex-direction: column !important;
      }
    }
  `;
__decorateClass([
  property({ attribute: "fallback" })
], OfferHeader.prototype, "fallback", 2);
__decorateClass([
  property({ type: Boolean })
], OfferHeader.prototype, "verticalDisplay", 2);
OfferHeader = __decorateClass([
  customElement("offer-header")
], OfferHeader);
export {
  OfferHeader
};
